import React from "react";
import { createPortal } from "react-dom";
import {
  hasCompleteApprovalDateRange,
  isApprovalDateRangeValid,
} from "../../utils/approvalDateFilters";
import "../admin/MessagesApproval/MessagesApproval.css";

export const EMPTY_GROUP_APPROVAL_FILTERS = {
  requestStatus: "",
  status: "",
  fromDate: "",
  toDate: "",
};

const ApprovedGroupMessagesFilterDrawer = ({
  isOpen,
  onClose,
  draftFilters,
  onDraftChange,
  onApply,
  onReset,
}) => {
  const today = new Date().toISOString().split("T")[0];

  const updateField = (field, value) => {
    onDraftChange({ ...draftFilters, [field]: value });
  };

  if (!isOpen) return null;

  const canApply = isApprovalDateRangeValid(draftFilters.fromDate, draftFilters.toDate);

  return createPortal(
    <>
      <div className="messages-approval-filter-overlay" onClick={onClose} />
      <div className="messages-approval-filter-drawer">
        <div className="messages-approval-filter-drawer__header">
          <h2 className="messages-approval-filter-drawer__title">Filter</h2>
          <button
            type="button"
            className="messages-approval-filter-drawer__close"
            onClick={onClose}
            aria-label="Close filters"
          >
            ×
          </button>
        </div>

        <div className="messages-approval-filter-drawer__body">
          <div className="messages-approval-filter-grid">
            <div className="messages-approval-filter-field">
              <label>Request Status</label>
              <select
                value={draftFilters.requestStatus}
                onChange={(e) => updateField("requestStatus", e.target.value)}
              >
                <option value="">All</option>
                <option value="approved">Approved</option>
                <option value="decline">Declined</option>
                <option value="pending">Pending</option>
                <option value="sent">Sent</option>
              </select>
            </div>

            <div className="messages-approval-filter-field">
              {/* <label>Status</label>
              <select
                value={draftFilters.status}
                onChange={(e) => updateField("status", e.target.value)}
              >
                <option value="">All</option>
                <option value="sent">Sent</option>
              </select> */}
            </div>

            <div className="messages-approval-filter-field">
              <label>From Date</label>
              <input
                type="date"
                value={draftFilters.fromDate}
                max={draftFilters.toDate || today}
                onChange={(e) => updateField("fromDate", e.target.value)}
              />
            </div>

            <div className="messages-approval-filter-field">
              <label>To Date</label>
              <input
                type="date"
                value={draftFilters.toDate}
                min={draftFilters.fromDate || undefined}
                max={today}
                onChange={(e) => updateField("toDate", e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="messages-approval-filter-drawer__footer">
          <button
            type="button"
            className="messages-approval-filter-btn reset"
            onClick={onReset}
          >
            Reset
          </button>
          <button
            type="button"
            className="messages-approval-filter-btn apply"
            onClick={onApply}
            disabled={!canApply}
          >
            Apply
          </button>
        </div>
      </div>
    </>,
    document.body
  );
};

export const hasActiveGroupApprovalFilters = (filters) => {
  if (!filters) return false;
  const datesActive = hasCompleteApprovalDateRange(filters.fromDate, filters.toDate);
  const otherActive = Object.entries(filters).some(([key, value]) => {
    if (key === "fromDate" || key === "toDate") return false;
    if (key.endsWith("Id") && !value) return false;
    return value != null && String(value).trim() !== "";
  });
  return datesActive || otherActive;
};

export default ApprovedGroupMessagesFilterDrawer;
